import { render, staticRenderFns } from "./rel-livro-fiscal.vue?vue&type=template&id=d9f90b50&"
import script from "./rel-livro-fiscal.vue?vue&type=script&lang=js&"
export * from "./rel-livro-fiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports